import type { GoalFrequency } from "@colab/shared";

// SPA copy of apps/api/src/services/goals-period.ts. Pure helper — no
// dependencies, fine to duplicate so we don't drag the worker bundle into
// the SPA via @colab/shared (the helper lives under apps/api today).

export function defaultPeriodFor(
  frequency: GoalFrequency,
  now: Date = new Date(),
): { start: string; end: string } | null {
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  switch (frequency) {
    case "monthly": {
      const start = new Date(Date.UTC(y, m, 1));
      const end = new Date(Date.UTC(y, m + 1, 0));
      return { start: isoDate(start), end: isoDate(end) };
    }
    case "quarterly": {
      const qStart = Math.floor(m / 3) * 3;
      const start = new Date(Date.UTC(y, qStart, 1));
      const end = new Date(Date.UTC(y, qStart + 3, 0));
      return { start: isoDate(start), end: isoDate(end) };
    }
    case "yearly":
      return { start: `${y}-01-01`, end: `${y}-12-31` };
    case "one_off":
      return null;
  }
}

function isoDate(d: Date): string {
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
}
